import React, { FunctionComponent, SVGProps } from 'react'

export const IconArrowUp: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#858591"
      {...props}
    >
      <path
        d="M1 7L7 1L13 7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
